import React, { useState } from 'react';
// noinspection ES6CheckImport
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Header from '../../molecules/Header';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import Txt from '../../atoms/Txt';
import ProductCard from '../../organisms/ProductCard';

import { Container } from './styles';
import history from '../../../config/history';
import { createTransaction } from '../../../database/repositories/TransactionRepository';
import { fireFunctions, fireStore } from '../../../database/utils/firebase';

function PurchaseConfirm() {
  const [transResult, setTransResult] = useState(null);

  const cartProducts = useSelector((state) => state.cart);

  const confirmBuy = async () => {
    const map = ({ product, qty }) => ({
      productID: product.id,
      productCost: Number(product.price),
      deliveryCost: 10,
      quantity: qty,
      sellerID: product.seller
    });
    let refID;
    try {
      refID = await createTransaction(cartProducts.map(map));
      const createCharge = fireFunctions.httpsCallable('createCharge');
      const chargeUrl = await createCharge({ transactionId: refID });
      console.log('chargeUrl', chargeUrl);
      window.open(chargeUrl.data);
      setTransResult({ status: 'ok', msg: 'Transação iniciada com sucesso.' });
    } catch (error) {
      console.error(error.message);
      await fireStore.collection('transactions').doc(refID).delete();
      const trans = await fireStore
        .collection('transactions-items')
        .where('transactionID', '==', refID)
        .get();
      trans.docs.forEach((tran) => {
        tran.ref.delete();
      });
      setTransResult({ status: 'error', msg: error.message });
    }
  };

  return (
    <Container>
      {useSelector((state) => state.auth.user_logged_in) < 1 ? <Redirect to="/entrar" /> : null}
      <Header />
      <MainContent>
        <div className="signup-form-holder" style={{ flex: 1 }}>
          {cartProducts
            .filter((cart) => cart.product)
            .map(({ product, qty }, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <ProductCard product={product} qty={qty} key={index} index={index} />
            ))}
          <div className="button-container">
            <button onClick={confirmBuy}>Confirmar Compra</button>
          </div>
          {transResult ? <Txt>{transResult.msg}</Txt> : null}
          {transResult && transResult.status === 'ok'
            ? setTimeout(() => history.push('/usuario/compras/abertas'), 100)
            : null}
        </div>
      </MainContent>
      <Footer />
    </Container>
  );
}

export default PurchaseConfirm;
